import { HTTPClient } from '.';

export default {
  obterPorIdentificador(identificadorPagina) {
    return HTTPClient.get('/pagina-informativa', { params: { identificadorPagina } });
  },
};
